module.exports = __webpack_public_path__ + "static/newyear-04d90b58e67e718c408188c0542539dc.mp4";